import { TaskDashboardProvider } from "./context";
import { Layout } from "components/Layout/Layout";
import { TaskManagementDashBoardContainer } from "./TaskManagementDashBoardContainer";

export const TaskManagementDashboard = () => {
  return (
    <TaskDashboardProvider>
      <Layout>
        <TaskManagementDashBoardContainer />
      </Layout>
    </TaskDashboardProvider>
  );
};
